import React from "react";

// import {TransactionContext} from "../../../../../context";
// import {CustomBadges, TableLoading, TableNullData} from "../../../../../components";

import "./index.scss";
import {
  CustomBadges,
  CustomButton2,
  CustomIcon,
  CustomModal,
  TableNullData,
  UserInformation,
} from "../../../../../../components";
import utils from "../../../../../../utils";
import {
  GATEWAY,
  INVOICES_STATUS,
  PAYER_TYPE,
  PAY_TYPE,
  TRANSACTION_REASON,
} from "../../../../../../values/dropdownItems";
import Context from "../../../../../../context";
import { useTranslation } from "react-i18next";

type Props = {
  data: any;
};

const Body = ({ data }: Props) => {
  const { requestCompanyFactor, setShowModal, showModal, setSelectedDebt } =
    React.useContext(Context.CompanyFactorScreen);
  const [openInfoModal, setOpenInfoModal] = React.useState<boolean>(false);
  const docs = data?.data?.result?.docs;

  function onClickInfo() {
    setOpenInfoModal(!openInfoModal);
  }

  function onClickRow(index: number) {
    // setSelectedUserId(index);
    // setShowModal("SHOW");
  }

  const showInfoHandler = (debt: any) => {
    setSelectedDebt(debt);
    setShowModal("SHOW_DEBT_USER_INFO");
  };
  const payDebtHandler = (debt: any) => {
    setSelectedDebt(debt);
    setShowModal("PAY_DEBT");
  };

  const { t } = useTranslation();

  if (!docs || docs?.length <= 0) return <TableNullData />;
  return (
    <>
      <tbody id="find-transaction-body-container">
        {docs?.map((factor: any, index: number) => {
          let payerInfo: any = {};

          payerInfo = factor?.payerId;

          return (
            <tr
              key={`files-tr-${index}`}
              onClick={() => onClickRow(factor?.debtId?._id)}
            >
              <td onClick={onClickInfo}>
                <div className="table-index-number">
                  {requestCompanyFactor.page === 1
                    ? index + 1
                    : (requestCompanyFactor.page - 1) * 10 + index + 1}
                </div>
              </td>
              <td onClick={onClickInfo} className="table-text">
                <UserInformation
                  hideAvatar
                  name={factor?.driver?.firstName}
                  lastName={factor?.driver?.lastName}
                  phoneNumber={factor?.driver?.phoneNumber}
                />
              </td>{" "}
              <td onClick={onClickInfo} className="table-text">
                <UserInformation
                  hideAvatar
                  name={factor?.student?.firstName}
                  lastName={factor?.student?.lastName}
                  // phoneNumber={"موبایل اولیاء :‌" + factor?.parent?.phoneNumber}
                />
              </td>{" "}
              <td onClick={onClickInfo} className="table-text">
                {utils.convertNumberToPrice(factor.price)}
                {t("toman")}
              </td>{" "}
              <td onClick={onClickInfo} className="table-text">
                {utils?.convertGregorianToJalali({
                  date: factor.oldSubscriptionDate,
                })}
              </td>
              <td onClick={onClickInfo} className="table-text">
                {utils.convertGregorianToJalali({
                  date: factor.newSubscriptionDate,
                })}
              </td>
              <td onClick={onClickInfo} className="table-text">
                <CustomBadges
                  type={factor?.status === "PAID" ? "success" : "danger"}
                  title={
                    INVOICES_STATUS?.find((item) => item._id === factor?.status)
                      ?.name as string
                  }
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    </>
  );
};

export default Body;
